var _defs, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWayTosuccessCommIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 578,
    viewBox: "0 0 103 578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 62.895px;\n        opacity: 0.36;\n        fill: #99449a;\n        font-family: Poppins;\n        font-weight: 500;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Campaigns",
    className: "cls-1",
    transform: "translate(76.178 581.107) rotate(-90) scale(1.558)"
  }, "Campaigns")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWayTosuccessCommIcon2);
export default __webpack_public_path__ + "static/media/wayTosuccessCommIcon2.e35b3c058e6e956d1b93a40113dd4c5c.svg";
export { ForwardRef as ReactComponent };